import React, {useState, useContext, useEffect} from 'react'
import { Modal, Button, Typography, Input, DatePicker, Alert, Tag, Result, Flex, Card, List, Radio } from 'antd';
import { MdAdminPanelSettings, MdPermContactCalendar } from 'react-icons/md';
import axios from 'axios';
import AuthContext from "../../../contexts/AuthContext";
import mapicon from '../../../assets/mapicon.svg';
import { CheckCircleTwoTone } from '@ant-design/icons';
import moment from 'moment';




const AssignWebTask = ({ open, onHide, roadName, uid, onAssign, selectedRoadName, onTaskAssigned, taskDetails, selectedVideos }) => {
    const { role } = useContext(AuthContext);
    const [selectedUser, setSelectedUser] = useState({});
    const [users, setUsers] = useState([]);
    const [selectedAdmin, setSelectedAdmin] = useState('');
    const [admin, setAdmin] = useState([]);
    const [task, setTask] = useState('');
    const [description, setDescription] = useState('');
    const [dueDate, setDueDate] = useState(null);
    const [shift, setShift] = useState('day');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isTaskAssigned, setIsTaskAssigned] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const { Paragraph } = Typography;
    const { TextArea } = Input;

    // State for same Road ID functionality when multiple videos are selected
    const [commonRoadId, setCommonRoadId] = useState('');

    // Set common Road ID when multiple videos are selected
    useEffect(() => {
      if (selectedVideos && selectedVideos.length > 0) {
        // Get the first video's road_id or prompt for a new one
        const firstRoadId = selectedVideos[0].road_id;
        // Check if all selected videos have the same Road ID
        const allSameRoadId = selectedVideos.every(v => v.road_id === firstRoadId);
        setCommonRoadId(allSameRoadId ? firstRoadId : '');
      }
    }, [selectedVideos]);

    useEffect(() => {
      const fetchWebUsers = async () => {
        console.log('Fetching users - Role:', role, 'Open:', open);
        if (!open) {
          console.log('Modal not open, skipping user fetch');
          return;
        }
        if (role !== 'Admin') {
          console.log('User is not Admin, skipping user fetch');
          setError('Only Admin users can assign tasks');
          return;
        }
        setLoading(true);
        try {
          const token = JSON.parse(window.localStorage.getItem("token"));
          console.log('Fetching users from API...');
          const response = await axios.get(
            `${process.env.REACT_APP_BASE_URL}task/list_webusers`, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          });
  
          console.log('API Response:', response.data);
          if (!response.data.users) {
            throw new Error('Failed to fetch web users - no users in response');
          }
          const formattedUsers = response.data.users.map(user => ({
            label: `${user.name} (${user.unique_verification_code})`,
            value: user.name,
            unique_verification_code: user.unique_verification_code,
            email: user.email,
          }));
          console.log('Formatted users:', formattedUsers);
          setUsers(formattedUsers);
        } catch (error) {
          console.error('Error fetching users:', error);
          setError(`Error fetching users: ${error.message}`);
        } finally {
          setLoading(false);
        }
      };
  
      fetchWebUsers();
    }, [open, role]);
  
    useEffect(() => {
      const fetchAdminName = async () => {
        if (!open || role !== 'Admin') return;
        setLoading(true);
        try {
          const token = JSON.parse(window.localStorage.getItem("token"));
          const response = await axios.get(
            `${process.env.REACT_APP_BASE_URL}task/get_user_info`, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          });
  
          if (!response.data.result) {
            throw new Error('Failed to fetch admin name');
          }
          const fetchedAdmin = response.data.result;
          setAdmin([fetchedAdmin]);
          setSelectedAdmin(fetchedAdmin);
        } catch (error) {
          setError(error.message);
        } finally {
          setLoading(false);
        }
      };
      fetchAdminName();
    }, [open, role]);
  
    const assignTask = async () => {
      if (role !== 'Admin') {
        return;
      }
      setLoading(true);
      try {
        if (!selectedUser || !selectedUser.value || !selectedUser.unique_verification_code) {
          setError('Please select a user to assign the task.');
          return;
        }
        if (!task) {
          setError('Please fill Task Title');
          return;
        }
        if (!description) {
          setError('Please fill Task Description')
          return;
        }
        if (!dueDate) {
          setError('Please fill Due Date')
          return;
        }
        const assignedByName = selectedAdmin ? selectedAdmin.name : '';

        // Handle multiple videos - use common Road ID if provided
        const videoUids = selectedVideos && selectedVideos.length > 0
          ? selectedVideos.map(v => v.uid)
          : [uid];

        const roadIdToUse = commonRoadId || (selectedVideos && selectedVideos.length > 0 ? selectedVideos[0].road_id : null);

        const payload = {
          taskid: videoUids.length === 1 ? videoUids[0] : uid, // Single UID or comma-separated
          video_uids: videoUids, // Array of all video UIDs
          road_id: roadIdToUse, // Common Road ID for all videos
          assignedTo: selectedUser.value,
          assignedUserCode: selectedUser.unique_verification_code,
          assignedToUserEmail: selectedUser.email,
          roadNames: roadName,
          taskTitle: task,
          taskDescription: description,
          dueDate: dueDate,
          shift: shift,
          assignedBy: assignedByName,
        };
        const token = JSON.parse(window.localStorage.getItem("token"));
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}task/webtask_assign`, payload, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        console.log('Task assigned successfully:', response.data);
        onTaskAssigned();
        setIsTaskAssigned(true);
        setTimeout(() => {
          setIsTaskAssigned(false);
          onHide();
          resetForm();
        }, 5000);
        setSelectedUser({});
        setSelectedAdmin('');
        setTask('');
        setDescription('');
        setDueDate(null);
        setShift('day');
        setError(null);
      } catch (error) {
        setError(error.message);
        console.error('Error assigning task:', error);
      } finally {
        setLoading(false);
      }
    };
    const resetForm = () => {
      setSelectedUser({});
      setUsers([]);
      setSelectedAdmin('');
      setAdmin([]);
      setTask('');
      setDescription('');
      setDueDate(null);
      setShift('day');
      setError(null);
      setLoading(false);
    };
  
    const filteredUsers = users.filter(user =>
      user.label.toLowerCase().includes(searchQuery.toLowerCase())
    );
  
    const statusBodyTemplate = (taskDetails) => {
      const getStatusTag = (status) => {
        switch (status) {
          case 'Closed':
            return <Tag color="#ECECEC" style={{ color: '#425466' }}>Closed</Tag>;
          case 'Pending':
            return <Tag color="#FFFBD2" style={{ color: '#B35A04' }}>Pending</Tag>;
          case 'In Progress':
            return <Tag color="#EBF3FF" style={{ color: '#1967D2' }}>In Progress</Tag>;
          case 'Completed':
            return <Tag color="#DEFFE7" style={{ color: '#34A853' }}>Completed</Tag>;
          case 'Overdue':
            return <Tag color="#FFE3E3" style={{ color: '#DA2727' }}>Overdue</Tag>;
          default:
            return null;
        }
      };
  
      return taskDetails.status ? getStatusTag(taskDetails.status) : null;
    };
    const disabledDate = current => {
      return current && current < moment().startOf('day');
    };
  
    const renderContent = () => {
      if (isTaskAssigned) {
        return (
          <Result
            status="success"
            title="Successfully Assigned Task!"
            subTitle="The task has been successfully assigned. This message will close automatically."
          />
        );
      } else if (taskDetails) {
        return (
          <Card
            title={
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span>
                    Assigned Task Details
                  </span>
                  <span style={{ fontSize: 14, fontWeight: 400 }}>
                    Type: {taskDetails.taskType} Task
                  </span>
                </div>
  
                <div className="flex items-center" style={{ position: 'relative', width: 250, height: 45 }}>
                  <MdAdminPanelSettings style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', zIndex: 10 }} />
                  <Input
                    disabled={true}
                    value={`Assigned by ${taskDetails.assignedBy}`}
                    style={{ paddingLeft: 35, width: '100%', height: '100%', borderRadius: 20, fontWeight: 600 }}
                  />
                </div>
              </div>
            }
            bordered={false}
            style={{ width: '100%' }}
          >
            <Paragraph style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#EFFBFF', padding: '10px', margin: '0 -24px', textAlign: 'center' }}>
              <img src={mapicon} alt="map" />{taskDetails.roadNames}
            </Paragraph>
            <Flex gap="small">
              <Flex gap="small" vertical>
                <div
                  id="scrollableDiv"
                  style={{
                    height: 100,
                    width: 320,
                    backgroundColor: '#fff',
                    overflow: 'hidden',
                    margin: '16px 0px',
                    padding: '16px',
                    border: '1px solid #fff',
                    boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  <div style={{ fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>Assigned user for this task</div>
                  <div
                    style={{
                      overflowY: 'auto',
                      maxHeight: '58px',
                    }}
                  >
                    <List size="small">
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '4px',
                          padding: '10px',
                          backgroundColor: 'transparent',
                        }}
                      >
                        <MdPermContactCalendar />{taskDetails.assignedTo}
                      </div>
                    </List>
                  </div>
                </div>
                <div
                  id="scrollableDiv"
                  style={{
                    height: 190,
                    width: 320,
                    backgroundColor: '#fff',
                    overflow: 'hidden',
                    padding: '16px',
                    border: '1px solid #fff',
                    boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  <List size="small"
                    header={<div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span style={{ fontSize: 16, fontWeight: 600 }}>Task status</span>
                      <span>{statusBodyTemplate(taskDetails)}</span>
                    </div>
                    }
                  >
                    <div style={{ display: 'flex', marginTop: '5px', justifyContent: 'space-between' }}>
                      <span style={{ fontSize: 16, fontWeight: 600 }}> Created on </span>
                      <span>{taskDetails.created_at}</span>
                    </div>
                    {taskDetails.accepted_at && (
                      <div style={{ display: 'flex', marginTop: '5px', justifyContent: 'space-between' }}>
                        <span style={{ fontSize: 16, fontWeight: 600 }}> Accepted on </span>
                        <span>{taskDetails.accepted_at}</span>
                      </div>
                    )}
                    {taskDetails.completed_at && (
                      <div style={{ display: 'flex', marginTop: '5px', justifyContent: 'space-between' }}>
                        <span style={{ fontSize: 16, fontWeight: 600 }}> Completed on </span>
                        <span>{taskDetails.completed_at}</span>
                      </div>
                    )}
                    {taskDetails.closed_at && (
                      <div style={{ display: 'flex', marginTop: '5px', justifyContent: 'space-between' }}>
                        <span style={{ fontSize: 16, fontWeight: 600 }}> Closed on </span>
                        <span>{taskDetails.closed_at}</span>
                      </div>
                    )}
                  </List>
                </div>
              </Flex>
              <div
                id="taskdiv"
                style={{
                  height: 313,
                  flexGrow: 1,
                  overflow: 'hidden',
                  margin: '16px 0px',
                  padding: '0px 16px',
                  border: '1px solid #fff',
                  boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.1)',
                  overflowY: 'auto',
                }}
              >
                <Flex gap="small" vertical>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ fontSize: 16, fontWeight: 600 }}>Task Title</span>
                    <span >{taskDetails.taskTitle}</span>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', marginTop: 2 }}>
                    <span style={{ fontSize: 16, fontWeight: 600 }}>Task Description</span>
                    <span>{taskDetails.taskDescription}</span>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 16 }}>
                    <span style={{ marginRight: '16px', fontSize: 16, fontWeight: 600 }}>Due Date</span>
                    <span>{taskDetails.dueDate}</span>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 2 }}>
                    <span style={{ marginRight: '32px', fontSize: 16, fontWeight: 600 }}>Task ID</span>
                    <span>{taskDetails.taskid}</span>
                  </div>
                  {taskDetails.feedback && (
                    <div style={{ display: 'flex', flexDirection: 'column', marginTop: 2, marginBottom: 4 }}>
                      <span style={{ fontSize: 16, fontWeight: 600 }}>Feedback from the assigned user</span>
                      <TextArea
                        disabled={true}
                        placeholder="Feedback from the assigned user"
                        autoSize={{ minRows: 3, maxRows: 4 }}
                        style={{ width: '100%', height: '100%', fontWeight: 600, backgroundColor: '#EDEDED' }}
                        value={taskDetails.feedback}
                      />
                    </div>
                  )}
                </Flex>
              </div>
            </Flex>
          </Card >
        );
      } else {
        return (
          <>
            <>
              {isTaskAssigned ? (
                <Result
                  status="success"
                  title="Successfully Assigned Task!"
                  subTitle="The task has been successfully assigned. This message will close automatically."
                />
              ) : (
                <>
                  <Card
                    title={
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>Assign User Maintenance Task</span>
                        <div className="flex items-center" style={{ position: 'relative', width: 250, height: 45 }}>
                          <MdAdminPanelSettings style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', zIndex: 10 }} />
                          <Input
                            disabled={true}
                            value={selectedAdmin ? `Assigne by ${selectedAdmin.name}` : ''}
                            style={{ paddingLeft: 35, width: '100%', height: '100%', borderRadius: 20 }}
                          />
                        </div>
                      </div>
                    }
                    bordered={false}
                    style={{ width: '100%' }}
                  >
                    <Paragraph style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#EFFBFF', padding: '10px', margin: '0 -24px', textAlign: 'center', flexDirection: 'column' }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={mapicon} alt="map" />{roadName}
                      </div>
                      {selectedVideos && selectedVideos.length > 1 && (
                        <div style={{ marginTop: '8px', fontSize: '12px', color: '#1967D2', fontWeight: 600 }}>
                          {selectedVideos.length} videos selected {commonRoadId && `• Common Road ID: ${commonRoadId}`}
                        </div>
                      )}
                    </Paragraph>
                    <Flex gap="small">
                      <div
                        id="scrollableDiv"
                        style={{
                          height: 300,
                          width: 320,
                          backgroundColor: '#ededed',
                          overflow: 'hidden',
                          margin: '16px 0px',
                          padding: '16px',
                          border: '1px solid rgba(140, 140, 140, 0.35)',
                        }}
                      >
                        <div style={{ fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>Select a user for this task</div>
                        <div style={{ fontSize: '12px', color: '#666', marginBottom: '8px' }}>
                          Debug: Role={role}, Users={users.length}, Loading={loading ? 'Yes' : 'No'}
                        </div>
                        <input
                          type="text"
                          placeholder="   Search for a users"
                          style={{ width: '100%', height: 30, borderRadius: 5, marginBottom: '8px' }}
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        <div
                          style={{
                            overflowY: 'auto',
                            maxHeight: '240px',
                          }}
                        >
                          {selectedUser.value ? (
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                padding: '10px',
                                backgroundColor: '#f0f0f0',
                              }}
                            >
                              <MdPermContactCalendar />{selectedUser.label}
                            </div>
                          ) : (
                            <List size="small">
                              {filteredUsers.map((user, index) => (
                                <div
                                  key={index}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    padding: '10px',
                                    cursor: 'pointer',
                                    backgroundColor: 'transparent',
                                  }}
                                  onClick={() => setSelectedUser(user)}
                                >
                                  <MdPermContactCalendar />{user.label}
                                </div>
                              ))}
                            </List>
                          )}
                        </div>
                        {selectedUser.value && (
                          <button
                            style={{
                              marginTop: '10px',
                              color: '#007bff',
                              cursor: 'pointer',
                            }}
                            onClick={() => setSelectedUser({})}
                          >
                            Change User
                          </button>
                        )}
                      </div>
                      <div
                        id="taskdiv"
                        style={{
                          height: 320,
                          flexGrow: 1,
                          overflow: 'hidden',
                          margin: '16px 0px',
                          padding: '0px 16px',
  
                        }}
                      >
                        <Flex gap="small" vertical>
                          <div className="p-field">
                            <label htmlFor="task" style={{ display: 'block', fontSize: '16px', fontWeight: '600' }}>Task Title</label>
                            <TextArea
                              id="task"
                              value={task}
                              autoSize={{ minRows: 2, maxRows: 4 }}
                              onChange={(e) => setTask(e.target.value)}
                              style={{ width: '100%', padding: '0.2rem', borderColor: '#007bff', borderWidth: '1px', borderStyle: 'solid' }}
                            />
                          </div>
                          <div className="p-field">
                            <label htmlFor="description" style={{ display: 'block', fontSize: '16px', fontWeight: '600' }}>Task Description</label>
                            <TextArea
                              id="description"
                              value={description}
                              onChange={(e) => setDescription(e.target.value)}
                              autoSize={{ minRows: 5, maxRows: 6 }}
                              style={{ width: '100%', padding: '0.2rem', borderColor: '#007bff', borderWidth: '1px', borderStyle: 'solid' }}
                            />
                          </div>
                          <div className="p-field">
                            <label htmlFor="date" style={{ display: 'block', fontSize: '16px', fontWeight: '600' }}>Due Date</label>
                            <DatePicker
                              id="date"
                              value={dueDate}
                              onChange={(date, dateString) => setDueDate(date)}
                              disabledDate={disabledDate}
                              style={{ width: '100%', padding: '0.2rem', borderColor: '#007bff', borderWidth: '1px', borderStyle: 'solid' }}
                            />
                          </div>
                          <div className="p-field">
                            <label htmlFor="shift" style={{ display: 'block', fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>Work Shift</label>
                            <Radio.Group
                              id="shift"
                              value={shift}
                              onChange={(e) => setShift(e.target.value)}
                              style={{ width: '100%' }}
                            >
                              <Radio.Button value="day" style={{ width: '48%', textAlign: 'center' }}>
                                🌅 Day Shift
                              </Radio.Button>
                              <Radio.Button value="night" style={{ width: '48%', textAlign: 'center', marginLeft: '4%' }}>
                                🌙 Night Shift
                              </Radio.Button>
                            </Radio.Group>
                          </div>
                        </Flex>
                      </div>
                    </Flex>
                    {error && (<Alert message={error} type="error" showIcon closable onClose={() => setError(null)} style={{ marginBottom: 1 }} />)}
                  </Card>
                </>
              )}
            </>
          </>
        );
      }
    };
    const footerContent = () => {
      if (taskDetails) {
        return [<Button key="close" danger ghost onClick={onHide}>Close this window</Button>];
      } else if (!isTaskAssigned) {
        return [
          <div key="button-container" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button key="cancel" danger onClick={() => { onHide(); resetForm(); }} ghost>Cancel</Button>
            <Button key="assign" type="primary" icon={<CheckCircleTwoTone />} onClick={assignTask} style={{ background: '#1967D2' }}>Submit for AI Processing</Button>
          </div>
        ];
      }
      return null;
    };
  
  
    return (
      <>
        {role === 'Admin' && (
          <Modal
            centered
            closable={false}
            open={open}
            onCancel={onHide}
            footer={footerContent()}
            width="70vw"
            modal
          >
            {renderContent()}
          </Modal>
        )}
      </>
    );
  };

export default AssignWebTask